module.exports = __webpack_public_path__ + "img/spins_4.07c26524.png";